// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"7ecc69b6","453":"cc5f0c55"}[chunkId] + ".chunk.js";
};